import React from 'react';
import { PageDetails } from '../../../models/page';
import ContainedGrid from '@xingternal/xing-grid';
import { TopBar } from '@xingternal/top-bar';
import styles from './PageContentWithHeader.css';
import { PageContent } from '../../shared/PageContent';
import { TPageContentContainerProps } from '../PageContentContainer';
import { DownloadPdfButton } from './DownloadPdfButton';

export interface TPageContentWithHeaderProps
  extends TPageContentContainerProps {
  pageDetails: PageDetails;
}

export const PageContentWithHeader = ({
  pageDetails,
  slug,
  showHeader,
  showLiveDate,
  renderMetaComponent,
}: TPageContentWithHeaderProps): React.ReactElement => (
  <ContainedGrid className={styles.termContainer} type="standard">
    {showHeader && (
      <div className={styles.armstrongTopBarContainer}>
        <TopBar
          showOnLargerScreens={true}
          skipSearch
          title={null}
          backButtonUrl="/terms"
          action={<DownloadPdfButton slug={slug} />}
        />
      </div>
    )}
    {!showHeader && <div className={styles.headerSpacing} />}

    {renderMetaComponent(pageDetails)}

    <PageContent showLiveDate={showLiveDate} pageDetails={pageDetails} />
  </ContainedGrid>
);

export default PageContentWithHeader;
